import { Helmet } from "react-helmet-async";

const SITE_URL = "https://landpartner.co";
const DEFAULT_OG_IMAGE = `${SITE_URL}/img/og-image.jpg`;

interface PageSEOProps {
  title: string;
  description: string;
  path?: string;
  ogImage?: string;
  ogType?: string;
}

export default function PageSEO({
  title,
  description,
  path = "",
  ogImage = DEFAULT_OG_IMAGE,
  ogType = "website",
}: PageSEOProps) {
  const canonical = `${SITE_URL}${path}`;
  const fullTitle = title.includes("LandPartner")
    ? title
    : `${title} | LandPartner`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="LandPartner" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
